<div class="view-changer-tabs">
  <button
    nbButton size="small"
    (click)="showProductBlocks('list')"
    [status]="view !== 'list' ? 'control' : 'basic'"
    i18n-nbTooltip="@@BigThumbnails"
    nbTooltip="Большие миниатюры"
  >
    <nb-icon icon="grid-outline"/>
  </button>
  <button
    nbButton size="small"
    (click)="showProductBlocks('table')"
    [status]="view !== 'table' ? 'control' : 'basic'"
    i18n-nbTooltip="@@TableView"
    nbTooltip="Отображать таблицей"
  >
    <nb-icon icon="menu-outline"/>
  </button>
</div>
